/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ProcessingState {
  Pending = "pending",
  Running = "running",
  Completed = "completed",
  Failed = "failed",
  Cancelled = "cancelled",
}

export function instanceOfProcessingState(value: any): boolean {
  for (const key in ProcessingState) {
    if (Object.prototype.hasOwnProperty.call(ProcessingState, key)) {
      if (ProcessingState[key as keyof typeof ProcessingState] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ProcessingStateFromJSON(json: any): ProcessingState {
  return ProcessingStateFromJSONTyped(json, false);
}

export function ProcessingStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ProcessingState {
  return json as ProcessingState;
}

export function ProcessingStateToJSON(value?: ProcessingState | null): any {
  return value as any;
}

export function ProcessingStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ProcessingState {
  return value as ProcessingState;
}
